// src/components/ProjectCard.jsx
import React from "react";
import { motion } from "framer-motion";

const cardVariant = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      type: "spring",
      bounce: 0.3,
    },
  },
};

export default function ProjectCard({ project, onClick }) {
  function getImageUrl(img) {
    if (!img) return null;
    const API_BASE = process.env.REACT_APP_API_BASE || "https://palegreen-snake-884644.hostingersite.com/backend";
    const BASE = API_BASE.replace(/\/api$/, "");
    if (img.startsWith("/uploads")) {
      return `${BASE}${img}`;
    }
    return img;
  }

  const rawUrl = getImageUrl(project.image);
  const imageUrl = rawUrl ? encodeURI(rawUrl) : null;

  return (
    <motion.div
      className="cursor-pointer h-full"
      variants={cardVariant}
      initial="hidden"
      animate="show"
      whileHover={{ y: -8, scale: 1.02 }}
      onClick={onClick}
    >
      <div className="bg-black rounded-2xl shadow-md hover:shadow-xl overflow-hidden transition-all duration-300 h-full flex flex-col border border-white/10">
        <div className="h-48 w-full bg-slate-900 overflow-hidden flex items-center justify-center relative">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={project.name}
              className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
            />
          ) : (
            <span className="text-3xl font-bold text-slate-400">
              {project.name?.charAt(0) || "P"}
            </span>
          )}
        </div>
        <div className="p-5 flex-1 flex flex-col items-center justify-center bg-black">
          <h3 className="font-semibold text-lg mb-1 line-clamp-2 text-center text-white">
            {project.name}
          </h3>
          {project.location && (
            <p className="text-xs text-sky-400 font-medium tracking-wide mt-1">
              {project.location}
            </p>
          )}
        </div>
      </div>
    </motion.div>
  );
}
